// Module
var code = "<iframe v-if=\"providerIframeSrc\" class=\"paymentGatway_providerIframe\" :src=\"providerIframeSrc\" @load=\"handleProviderIframeLoadEvent\"></iframe> ";
// Exports
export default code;